import styled from 'styled-components';
import {
  white, blue, roboto, tekoMedium,
} from '../../../utils/theme';
import { mobile, tablet } from '../../../utils/breakpoints';

export const Container = styled.div`
  background-size: cover;
  height: 70vw;
  max-height: 840px;
  display: flex;
  align-items: center;
  position: relative;

  @media (max-width: ${mobile.max}px) {
    height: 100vw;
    display: block;
  }

  ${({ isVideo }) => isVideo
    && `
    height: 100%;
    max-height: none;

    @media (max-width: ${tablet.max}px) {
      height: auto;
      display: block;
    }
  `};
`;

export const Headline = styled.h3`
  text-align: center;
  width: 100%;
  padding: 70px 300px;
  color: ${blue};
  background: rgba(255, 255, 255, 0.95);
  ${roboto} font-size: 30px;
  letter-spacing: 0.82px;
  text-align: center;
  text-transform: none;

  @media (max-width: ${tablet.max}px) {
    padding: 70px 150px;
  }

  @media (max-width: ${tablet.max}px) {
    position: absolute;
    bottom: 0;
    padding: 30px;
    ${tekoMedium} font-size: 16px;
    letter-spacing: initial;
    line-height: 1.3;
    text-transform: uppercase;
    color: ${white};
    text-align: left;
    background-image: url('/images/follow-us-background.png');
    background-size: cover;
    background-color: ${blue};
  }

  strong {
    color: ${blue};
  }

  ${({ isVideo }) => isVideo
    && `
    position: absolute;
    z-index: 20;
    left: 0px;
    top: calc(50% - 138px);
    @media (max-width: ${tablet.max}px) {
      display: flex;
      position: relative;
      top: 0;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
    }
  `};
`;

export const SocialContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-top: 30px;

  a {
    border: 2px solid ${blue};
    display: flex;
    justify-content: center;
    align-items: center;
    width: 77px;
    height: 77px;
    margin: 0 15px;
    padding: 10px;

    transition: all 0.15s;

    svg {
      width: 100%;
      max-height: 100%;
    }

    .social-stroke {
      stroke: ${blue};
    }

    &:hover {
      background: ${blue};

      .social-stroke {
        stroke: white;
      }
    }
  }

  @media (max-width: ${tablet.max}px) {
    margin-top: 19px;

    a {
      color: ${white};
      background: ${blue};
      border: 1px solid ${white};
      height: 40px;
      width: 40px;
      margin-top: -20px;
      margin-left: 7px;
      margin-right: 7px;

      img {
        display: none;
      }

      .social-stroke {
        stroke: ${white};
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/components/dividers/styles/imageWithText.style.js